import { reportUiFailure, shouldReport } from "../report-failure.js";

export type ForcedLogoutCause =
  | "terminal_close"
  | "rejected"
  | "refresh_expired"
  | "reauth_budget_exhausted"
  | "reconnect_unauthorized";

// Two paths can end one session a moment apart: one logout is one report.
const FORCED_LOGOUT_INTERVAL_MS = 60_000;

// A session the person did not end (the logout rate). Refused token = refusal; an
// exhausted refresh budget = fault. `ended` is the login screen's enum, never prose.
export function reportForcedLogout(cause: ForcedLogoutCause, ended: string): void {
  if (shouldReport("auth.forced_logout", FORCED_LOGOUT_INTERVAL_MS)) {
    reportUiFailure(
      "auth.forced_logout",
      new Error(`session ended: ${cause}`),
      { ended },
      {
        code: cause,
        failureKind: cause === "reauth_budget_exhausted" ? "fault" : "refusal",
      },
    );
  }
}
